import * as Effects from 'redux-saga/effects';
import { CreateInit } from '~/store/modules/_core/competenceEvents/duck';
import { actions, Types } from './duck';
import { Action } from '~/helpers/util/reducers';
import { APIError } from '~/domain/api/errors';
import * as CompetenceEventService from '~/store/modules/_core/competenceEvents/service';
import * as SiteService from '~/store/modules/_core/sites/service';

const call: any = Effects.call;
const put: any = Effects.put;
const takeLatest: any = Effects.takeLatest;

export function* fetchInitSaga() {
  try {
    yield call(SiteService.findMany);
    yield put(actions.fetchInitSuccess());
  } catch (error) {
    console.warn('error', error);
    yield put(actions.fetchInitFailure());
  }
}

export function* createSaga(action: Action<CreateInit>) {
  try {
    const {
      competenceId,
      startDate,
      endDate,
      firstDayAvailable,
      lastDayAvailable,
      siteId,
      justification,
      competenceEventType
    } = action.payload;
    yield call(CompetenceEventService.create, {
      competenceId,
      startDate,
      endDate,
      firstDayAvailable,
      lastDayAvailable,
      justification,
      competenceEventType,
      siteId
    });
    yield put(actions.createSuccess());
  } catch (error) {
    console.warn('error', error);
    if (error instanceof APIError) {
      yield put(actions.createFailure({ errorMessage: error.message }));
    } else {
      yield put(actions.createFailure({}));
    }
  }
}

export default [
  takeLatest(Types.FETCH_INIT, fetchInitSaga),
  takeLatest(Types.CREATE_INIT, createSaga)
];
